//Page Title: WordPress REST API Authentication

import { AiOutlineKey } from "react-icons/ai";
import { MdAutorenew, MdLockOutline, MdOutlineCloudDone, MdOutlineCreate, MdOutlineGroups, MdOutlineSettings, MdOutlineToken } from "react-icons/md";

//Main Video: https://youtu.be/KCSN66b3AqE	
export const restData = [
    {
      title: "Basic Authentication",
      video: false,
      videoId: "",
      videoType: "",
      icon: <MdLockOutline className='text-white fs-5' />
    },
    {
        title: "API Key Authentication",
        video: false,
        videoId: "",
        videoType: "",
        icon: <AiOutlineKey className='text-white fs-5' />
      },
      {
        title: "JWT Authentication",
        video: false,
        videoId: "",
        videoType: "",
        icon: <MdOutlineCloudDone className='text-white fs-5' />
      },
      {
        title: "OAuth 2.0",
        video: false,
        videoId: "",
        videoType: "",
        icon: <MdAutorenew className='text-white fs-5' />
      },
      {
        title: "Role-based Access to APIs",
        video: false,
        videoId: "",
        videoType: "",
        icon: <MdOutlineGroups className='text-white fs-5' />
      },
      {
        title: "Signature Validation: HSA & RSA Signing",
        video: false,
        videoId: "",
        videoType: "",
        icon: <MdOutlineCreate className='text-white fs-5' />
      },
      {
        title: "Custom Token Expiry",
        video: false,
        videoId: "",
        videoType: "",
        icon: <MdOutlineToken className='text-white fs-5' />
      },
      {
        title: "Configurable API Protection",
        video: false,
        videoId: "",
        videoType: "",
        icon: <MdOutlineSettings className='text-white fs-5' />
      }
]